export default "__VITE_ASSET__DWKXSLu8__"